import { render, staticRenderFns } from "./ListStack.vue?vue&type=template&id=013a79a1&scoped=true&"
import script from "./ListStack.vue?vue&type=script&lang=js&"
export * from "./ListStack.vue?vue&type=script&lang=js&"
import style0 from "./ListStack.vue?vue&type=style&index=0&id=013a79a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a79a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013a79a1')) {
      api.createRecord('013a79a1', component.options)
    } else {
      api.reload('013a79a1', component.options)
    }
    module.hot.accept("./ListStack.vue?vue&type=template&id=013a79a1&scoped=true&", function () {
      api.rerender('013a79a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/ListStack.vue"
export default component.exports